import DataCircle from "src/javascripts/components/DataCircle-storybook/DataCircle";

// Set content for top four boxes if present
export default function(settings) {

  let firstFour = $('#firstFour');

  if (firstFour.length !== 0) {
    $('#firstFour').empty();
    let firstFourResults = [];
    let i = 0;
    while ((firstFourResults.length < 4) && i < settings.json.data.length) {
      let d = settings.json.data[i];
      if ($.isNumeric(d.score_numeric)) {
        firstFourResults.push(settings.json.data[i]);
      }
      i++;
    }
    $.each(firstFourResults, function(i,d) {
      let num = Math.round(parseFloat(d.score_numeric));
      let percentage = num;
      let size = '98';
      let from_percentage;
      let show_blue = false;
      let customColor = null;
      let strokeWidth = 5;
      let letter_only = true;
      let dataCircle = DataCircle({
        percentage,
        from_percentage,
        size,
        show_blue,
        customColor,
        strokeWidth,
        letter_only
      });
      let text = "<div class=\'col-12 col-md-6 col-lg-4 col-xl-3\'><div class=\'Data\'>";
      text += "<div class=\'Dial\'>";
      text += "<div class=\'set-size charts-container\'>";
      text += "<div class=\'pie-wrapper progress-95\'>";
      text += "<div class=\'ethos-dataCircle\'>";
      text += "<div>";
      text += "</div></div></div>";
      text += "<div class=\'left-label\'>";
      text += "<div class=\'title\'>";
      if (typeof d.logo_url !== 'undefined') {
        text += "<div class=\'left-image\'><img alt=\'" + d.name + "\' src=\'" + d.logo_url + "\'></div>";
      }
      text += "<div class=\'title2\'>" + d.name + "</div>";
      text += "<div class=\'subtitle\'>" + d.score_sustainability + "</div>";
      text += "</div>";
      text += "</div>";
      text += "</div>";
      text += "</div>";
      $('#firstFour').append(text);
      $('#firstFour').find('.ethos-dataCircle:last').append(dataCircle);

    });
  }

}